import { render, staticRenderFns } from "./SearchProductPrice.vue?vue&type=template&id=c2ef4f86&"
import script from "./SearchProductPrice.vue?vue&type=script&lang=js&"
export * from "./SearchProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports